import React from "react";
import { Card } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DataTable from "examples/Tables/DataTable";
import useData from "../data/homepageData";
import ChooseHomepageProjectsPopup from "../components/choosenHomepageProjectsPopup";

const ChoosenHomepageProjects = () => {
  const { columns, rows, fetchHomepageProjects } = useData();

  return (
    <Card>
      <MDBox
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        px={3}
        pt={3}
      >
        <MDTypography variant="h5" gutterBottom>
          Home page projects
        </MDTypography>
      </MDBox>
      <MDBox mx={3} mt={2} px={3}>
        <ChooseHomepageProjectsPopup
          fetchHomepageProjects={fetchHomepageProjects}
        />
      </MDBox>
      <MDBox pt={2}>
        <DataTable
          table={{ columns, rows }}
          isSorted={true}
          entriesPerPage={false}
          showTotalEntries={true}
          noEndBorder
          canSearch={true}
        />
      </MDBox>
    </Card>
  );
};

export default ChoosenHomepageProjects;
